import { IDefineCommand } from 'core-ts-types';
import { APCourseInfoModel } from './../models/course_info_model';
angular
  .module('capability-ng-academic-planner')
  .service(
    'clearCourseInfoCommand',
    function clearCourseInfoCommandDefinition(
      defineCommandORM: IDefineCommand,
      ngAPCourseInfoModel: APCourseInfoModel
    ) {
      return defineCommandORM('clearCourseInfoCommand', function clearCourseInfoCommand(deferred) {
        ngAPCourseInfoModel.clear();
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/commands/clear_course_info_command.ts